import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { hideHamburgerMenu, hideSearchForm } from './store/actions/menusActions';
import Header from './Components/LandingPage/Header/Header';
import Footer from './Components/LandingPage/Footer/Footer';
import './App.scss';

export default function App() {
  const dispatch = useDispatch();
  const {
    isHamburgerMenuActive,
    isSearchFormActive,
  } = useSelector((state) => state.menus);

  const clickHandler = () => {
    if (isHamburgerMenuActive) {
      dispatch(hideHamburgerMenu());
    }

    if (isSearchFormActive) {
      dispatch(hideSearchForm());
    }
  };

  return (
    <div className="App">
      <Header />
      <main
        className="main"
        aria-hidden="true"
        onClick={clickHandler}
      >
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
